var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9744 3.53847C6.86765 3.53847 3.53847 6.86765 3.53847 10.9744C3.53847 15.0812 6.86765 18.4103 10.9744 18.4103C12.9825 18.4103 14.8046 17.6144 16.1426 16.3207C16.1666 16.2873 16.1937 16.2553 16.2238 16.2253C16.2539 16.1952 16.2859 16.1681 16.3194 16.144C17.6138 14.8059 18.4103 12.9832 18.4103 10.9744C18.4103 6.86765 15.0812 3.53847 10.9744 3.53847ZM17.8403 16.7539C19.156 15.1925 19.9488 13.1761 19.9488 10.9744C19.9488 6.01798 15.9308 2 10.9744 2C6.01798 2 2 6.01798 2 10.9744C2 15.9308 6.01798 19.9488 10.9744 19.9488C13.1753 19.9488 15.1911 19.1566 16.7523 17.8417L20.6853 21.7747C20.9857 22.0751 21.4728 22.0751 21.7732 21.7747C22.0736 21.4743 22.0736 20.9872 21.7732 20.6868L17.8403 16.7539Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigSearch);
export default __webpack_public_path__ + "static/media/big-search.6bc98277ff0f74061578fd84c5988492.svg";
export { ForwardRef as ReactComponent };